import React from 'react';
import cns from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ArrowDownIcon, CloseIcon } from 'components';

import './mobile-menu.scss';

const MobileMenuList = ({
  data = [],
  isOpen,
  handleHideModal,
  handleCheckActive,
  handleIsOpen,
  handleIsGroupActive,
}) => {
  return (
    <nav className="mobile-menu-container">
      <CloseIcon
        className="mobile-menu-container_close-icon"
        onClick={handleHideModal}
      />
      {data.map(({ id, title, route, childrens }, index) => (
        <div key={id}>
          {childrens ? (
            <div>
              <div
                className={cns('mobile-menu-item header-nav__text', {
                  active: handleIsGroupActive(title),
                })}
                onClick={() => handleIsOpen(index)}
              >
                {title}
                <ArrowDownIcon
                  width="12px"
                  height="12px"
                  className={
                    isOpen.includes(index)
                      ? 'routing-arrow_down'
                      : 'routing-arrow_up'
                  }
                />
              </div>
              <div
                className={`mobile-menu-sub-container mobile-menu-sub-container${
                  isOpen.includes(index) ? '__open-menu' : '__close-menu'
                }`}
              >
                {childrens.map(({ id, title, route }) => (
                  <Link
                    key={id}
                    onClick={handleHideModal}
                    to={route}
                    className={cns('header-nav__text mobile-menu__item', {
                      active: handleCheckActive(route),
                    })}
                  >
                    {title}
                  </Link>
                ))}
              </div>
            </div>
          ) : (
            <Link
              to={route}
              onClick={handleHideModal}
              className={cns('header-nav__text', {
                active: handleCheckActive(route),
              })}
            >
              {title}
            </Link>
          )}
        </div>
      ))}
    </nav>
  );
};

MobileMenuList.propTypes = {
  data: PropTypes.array,
  isOpen: PropTypes.array,
  handleHideModal: PropTypes.func,
  handleCheckActive: PropTypes.func,
  handleIsOpen: PropTypes.func,
  handleIsGroupActive: PropTypes.func,
};

export default MobileMenuList;
